(function () {
	'use strict';
	angular.module('mx.SolutionBuilderAgent').directive('mxServiceContext', [
		function mxServiceContextDirective() {
			MxServiceContext.$inject = ['$scope', '$q', 'mx.SolutionBuilderAgent.ExternalServiceManager'];
			function MxServiceContext($scope, $q, externalServiceManager) {
				const vm = this;
				var servicePromiseDefer = $q.defer();
				var dataModelPromiseDefer = $q.defer();
				vm.$servicePromise = servicePromiseDefer.promise;
				vm.$dataModelPromise = dataModelPromiseDefer.promise;

				vm.$onInit = function () {};

				var watch = $scope.$watch('mxServiceContextController.mxServiceContext', function () {
					if (vm.mxServiceContext) {
						if (vm.mxServiceContext.mxServiceContext) {
							vm.$servicePromise = vm.mxServiceContext.$servicePromise;
							vm.$dataModelPromise = vm.mxServiceContext.$dataModelPromise;
							vm.mxServiceContext = vm.mxServiceContext.mxServiceContext;
						} else {
							vm.mxServiceContext = typeof vm.mxServiceContext === 'string' ? JSON.parse(vm.mxServiceContext) : vm.mxServiceContext;

							if (!vm.mxServiceContext.entityName) {
								vm.mxServiceContext.entityName = ((vm.mxServiceContext.Context && vm.mxServiceContext.Context.Object) || {}).Type || '';
							}

							var entityName = vm.mxServiceContext.entityName;
							if (externalServiceManager.isService(entityName)) {
								servicePromiseDefer.resolve(externalServiceManager.getOperationInfo(entityName, mx.SolutionBuilderAgent.SupportedOperations.ReadObject));
							} else {
								servicePromiseDefer.resolve({});
							}
							dataModelPromiseDefer.resolve(vm.mxServiceContext);
						}
						watch();
					}
				});
				return vm;
			}

			return {
				restrict: 'A',
				bindToController: {
					mxServiceContext: '<',
					info: '<mxServiceContextInfo',
				},
				controller: MxServiceContext,
				controllerAs: 'mxServiceContextController',
			};
		},
	]);
})();
